import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import filters from "./misc/filters";
import "./styles/base/main.scss";

Vue.filter("capitalize", filters.capitalize);

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  next();
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
